import { type BreakerQuestion } from '@/features/jobs/questions/questions'
import { QuestionAnswerEditorViewModelBase } from '@/features/jobs/questions/QuestionAnswerEditorViewModelBase'
import { action } from 'mobx'
import { QuestionValidationResult } from '@/features/jobs/questions/question-validation-result'

export class BreakerQuestionAnswerEditorViewModel extends QuestionAnswerEditorViewModelBase<BreakerQuestion> {
  readonly type = 'Breaker'
  readonly isAnswered = false
  readonly answer = null
  readonly textAnswer = null

  constructor(private readonly _goBack: () => unknown) {
    super()
  }

  validate(): QuestionValidationResult {
    return QuestionValidationResult.failed([
      'Please go back and change your answer.',
    ])
  }

  @action.bound
  set(_question: BreakerQuestion) {
    // No-op - breaker questions don't have any state.
  }

  /**
   * Navigates back.
   */
  @action.bound
  goBack() {
    this._goBack()
  }
}
